module.exports = __webpack_public_path__ + "static/media/vnda18.97b48a11.png";